/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import { cloneDeep, isEqual } from 'lodash';
import Accordion from 'shared/ui/components/Accordion.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import LeadsEnrichmentSettings from 'ui/components/leads/LeadsEnrichmentSettings.vue';
import LeadsAutomaticMappingPromptModal from 'shared/ui/components/modals/LeadsAutomaticMappingPromptModal.vue';
import MappedFields from 'shared/ui/components/MappedFields.vue';
import { setUpAngularUnsavedChangesWarning } from 'shared/libs/utils/unsaved-changes-warning';
import { getFieldsForMapping } from 'libs/utils/metadata';

const INTEGRATION_EXCLUDED_FIELDS = new Set(['fp_ext_id']);

const __vue_script__ = {
    name: 'LeadsSettings',

    components: { Accordion, BaseSelect, LeadsEnrichmentSettings, LeadsAutomaticMappingPromptModal, MappedFields },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            registry: {},
            settings: {},
            organisation: {},
            prospectMetadata: {},
            showCaptureMethods: false,
            loading: true,
            ready: false,
            submitting: false,
            innerValue: {
                qr_scan_api_fields_map: {},
                qr_scan_api_fields_to_populate: [],
            },
            enrichmentConfigs: [],
            savedEnrichmentIntegrations: {},
            cleanupHook: null,
            congressApiReturnedKeys: [],
        };
    },

    computed: {
        disabled() {
            return this.loading || this.submitting;
        },
        canEditAPISettings() {
            return this.$services.user.hasPermission('leads.edit_qr_scan_api_settings');
        },
        canManageAutomaticMapping() {
            return this.innerValue.allow_ocr_scanner && (
                this.innerValue?.allow_automatic_mapping
                // do not brutally hide the option if the user clicks on the switch disabling the option
                || this.settings.leads.allow_automatic_mapping
                || this.organisation?.workspace_defaults?.ai_mapping_for_ocr_lead_scanning
            );
        },
        canEditPrompt() {
            return this.$services.user.matchesRoles({ globalRole: this.$const.ROLE_SPOTME });
        },

        congressApiFieldsToPopulateOptions() {
            const map = this.innerValue?.qr_scan_api_fields_map || {};
            const mappedMetadataFields = Object.values(map).filter(field => field && !INTEGRATION_EXCLUDED_FIELDS.has(field));

            if (mappedMetadataFields.length) {
                return mappedMetadataFields.map(field => ({ value: field, label: this.prospectMetadata[field]?.label || field }));
            }

            return Object.values(this.prospectMetadata)
                .filter(field => field && !INTEGRATION_EXCLUDED_FIELDS.has(field.name))
                .map(field => ({ value: field.name, label: field.label || field.name }));
        },
    },

    watch: {
        'innerValue.allow_ocr_scanner'(value) {
            if (!value && this.innerValue.allow_automatic_mapping) {
                this.innerValue.allow_automatic_mapping = false;
            }
        },
        settings: {
            deep: true,
            handler() {
                const leadsSettings = this.settings?.leads || {};

                this.innerValue = { ...leadsSettings };
                this.innerValue.enrichment_integrations = this.filterValidIntegrations(
                    this.innerValue.enrichment_integrations,
                );

                if (!this.innerValue.qr_scan_api_fields_map) {
                    this.$set(this.innerValue, 'qr_scan_api_fields_map', {});
                }

                if (!Array.isArray(this.innerValue.qr_scan_api_fields_to_populate)) {
                    this.$set(this.innerValue, 'qr_scan_api_fields_to_populate', []);
                }

                // used to detect unsaved mapping changes.
                this.savedEnrichmentIntegrations = cloneDeep(this.innerValue.enrichment_integrations || {});
            }
        }
    },

    async created() {
        await this.loadSettings();
    },

    mounted() {
        this.cleanupHook = this.setUpWarnOnUnsavedChanges();
    },

    beforeDestroy() {
        try {
            if (typeof this.cleanupHook === 'function') {
                this.cleanupHook();
            }
        } catch (err) {
            console.warn('[LeadsSettings] cleanup hook failed', err);
        }
    },

    methods: {
        setUpWarnOnUnsavedChanges() {
            return setUpAngularUnsavedChangesWarning({
                isDirty: () => this.hasUnsavedEnrichmentMappingChanges(),
                warningText: this.$t('general.forms.dirty_integration_mapping_fields').toString(),
            });
        },

        hasUnsavedEnrichmentMappingChanges() {
            const saved = this.savedEnrichmentIntegrations || {};
            const current = this.innerValue?.enrichment_integrations || {};
            const ids = new Set([...Object.keys(saved), ...Object.keys(current)]);

            return Array.from(ids)
                .some((id) => {
                    const savedMap = saved?.[id]?.integration_fields_map || {};
                    const currentMap = current?.[id]?.integration_fields_map || {};
                    return !isEqual(savedMap, currentMap);
                });
        },

        async loadSettings(skipCache = false) {
            try {
                console.debug(`[${this.$options.name}] Loading settings`);
                const settings = await this.$services.settings.getSettings(this.params.event._id, skipCache ? 0 : 5000);
                const registry = await this.$services.settings.getRegistrySettings(this.params.event._id, 'leads');
                try {
                    this.organisation = await this.$services.org.getOrg(this.$services.org.getNameFromId(this.params.event.ownerId));
                } catch (err) {
                    if (err.status !== 403) {
                        throw err;
                    }
                    // ignore 403 error. This happens when the person is an org guest
                }

                // Check if the universal-lead-capture is installed, i.e. if registry has the key allow_ocr_scanner.
                this.showCaptureMethods = registry.allow_ocr_scanner !== undefined;
                this.registry = registry;
                this.settings = settings;

                const prospectMetadata = await this.$services.metadata.getMetadataForType(this.params.event._id, 'prospect')
                    .catch(err => {
                        console.error('[LeadsSettings] could not get metadata', err);
                        return {};
                    });
                this.prospectMetadata = getFieldsForMapping(prospectMetadata, ['fp_ext_id']);

                this.congressApiReturnedKeys = await this.$services.integrations.getCongressApiReturnedKeysForMapping(this.params.event._id);
            } catch (error) {
                console.error(`[${this.$options.name}] Could not load current settings`, error);

                this.notify('leads.settings.error_loading', 'error', 15000);
            } finally {
                this.loading = false;
                this.ready = true;
            }
        },

        /**
         * Saves the settings.
         */
        async save(overrides = {}) {
            let success = false;

            try {
                console.info(`[${this.$options.name}] Saving settings`, this.innerValue);
                this.submitting = true;

                // keep the key of deleted integration with `null` value to remove it from the db
                // instead of dictree adding `_to_prune: true` to it and keeping the whole object
                const integrations = { ...this.innerValue.enrichment_integrations };
                for (const key of Object.keys(this.savedEnrichmentIntegrations)) {
                    integrations[key] = integrations[key] ? integrations[key] : null;
                }
                const toSave = {
                    ...this.innerValue,
                    enrichment_integrations: integrations,
                    ...overrides,
                };

                await this.$services.settings.saveSetting(this.params.event._id, 'leads', toSave);

                success = true;
                this.notify('general_settings.messages.settings_save_success');

            } catch (error) {
                console.error(`[${this.$options.name}] Error saving settings`, error);

                this.notify('general_settings.messages.settings_save_failure', 'error');

            } finally {
                this.loadSettings(true);
                this.submitting = false;
            }
            return success;
        },

        notify(key, type = 'success', duration = 5000) {
            this.$notify({
                group: 'flashes',
                text: this.$t(key).toString(),
                type,
                duration,
            });
        },

        editPrompt() {
            this.$modal.show(
                LeadsAutomaticMappingPromptModal,
                {
                    settings: this.innerValue,
                    defaultPrompts: {
                        [this.$const.PLATFORMS.IOS]: this.registry.automatic_mapping_prompt_ios.default,
                        [this.$const.PLATFORMS.ANDROID]: this.registry.automatic_mapping_prompt_android.default,
                    },
                    save: this.save,
                },
                {
                    height: 'auto',
                    clickToClose: false,
                    adaptive: true
                }
            );
        },

        /** @param {Record<stringRecord<string,unknown>>} [integrations] */
        filterValidIntegrations(integrations = {}) {
            return Object.entries(integrations).reduce((acc, [ key, integration ]) => {
                if (integration && !integration._to_prune) {
                    acc[key] = integration;
                }
                return acc;
            }, {});
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads-settings"},[_c('div',{staticClass:"content"},[(_vm.ready)?_c('div',{staticClass:"panels panels-b2 view-wrapper"},[_c('div',{staticClass:"panel"},[_c('p',{staticClass:"leads-settings-intro"},[_vm._v(_vm._s(_vm.$t('leads.settings.intro')))]),_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"leads-settings",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.save)}}},[_c('accordion',{attrs:{"headers-i18n-prefix":"leads","default-open-item":"capture_methods","animated":true,"slim":true,"unlimited-height":true},scopedSlots:_vm._u([(_vm.showCaptureMethods)?{key:"capture_methods",fn:function(ref){return [_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.capture_methods.intro')))]),_c('validation-provider',{attrs:{"slim":true,"name":"allow_qr_scaner"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_qr_scanner","control":_vm.registry.allow_qr_scanner,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_qr_scanner),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_qr_scanner", $$v)},expression:"innerValue.allow_qr_scanner"}})]}}],null,true)}),(_vm.innerValue.allow_qr_scanner)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"slim":true,"name":"qr_scan_api_name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"qr_scan_api_name","control":_vm.registry.qr_scan_api_name,"settings":_vm.settings,"avoid-password-managers":true,"event":_vm.params.event,"errors":errors,"disabled":!_vm.canEditAPISettings},model:{value:(_vm.innerValue.qr_scan_api_name),callback:function ($$v) {_vm.$set(_vm.innerValue, "qr_scan_api_name", $$v)},expression:"innerValue.qr_scan_api_name"}})]}}],null,true)}),(_vm.canEditAPISettings)?_c('validation-provider',{attrs:{"slim":true,"name":"qr_scan_api_url"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"qr_scan_api_url","avoid-password-managers":true,"control":_vm.registry.qr_scan_api_url,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.qr_scan_api_url),callback:function ($$v) {_vm.$set(_vm.innerValue, "qr_scan_api_url", $$v)},expression:"innerValue.qr_scan_api_url"}})]}}],null,true)}):_vm._e(),(_vm.canEditAPISettings)?_c('validation-provider',{attrs:{"slim":true,"name":"qr_scan_api_secret"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"qr_scan_api_secret","control":_vm.registry.qr_scan_api_secret,"settings":_vm.settings,"avoid-password-managers":true,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.qr_scan_api_secret),callback:function ($$v) {_vm.$set(_vm.innerValue, "qr_scan_api_secret", $$v)},expression:"innerValue.qr_scan_api_secret"}})]}}],null,true)}):_vm._e(),(_vm.canEditAPISettings && _vm.congressApiReturnedKeys.length)?_c('mapped-fields',{attrs:{"name":"qr_scan_api_fields_map","label":_vm.$t('integrations.fields_mapping'),"api-fields":_vm.congressApiReturnedKeys,"entity-type":'prospect',"eid":_vm.params.event._id,"tip":_vm.$t('leads.settings.integration_fields_mapping_tooltip')},model:{value:(_vm.innerValue.qr_scan_api_fields_map),callback:function ($$v) {_vm.$set(_vm.innerValue, "qr_scan_api_fields_map", $$v)},expression:"innerValue.qr_scan_api_fields_map"}}):_vm._e(),(_vm.canEditAPISettings && _vm.congressApiReturnedKeys.length)?_c('base-select',{attrs:{"name":"qr_scan_api_fields_to_populate","label":_vm.$t('leads.settings.integration_fields_to_populate'),"track-by":"value","taggable":true,"hint-after-label":true,"multiple":true,"options":_vm.congressApiFieldsToPopulateOptions,"emitOptionValueOnly":true},model:{value:(_vm.innerValue.qr_scan_api_fields_to_populate),callback:function ($$v) {_vm.$set(_vm.innerValue, "qr_scan_api_fields_to_populate", $$v)},expression:"innerValue.qr_scan_api_fields_to_populate"}}):_vm._e()],1):_vm._e(),_c('validation-provider',{attrs:{"slim":true,"name":"allow_ocr_scanner"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_ocr_scanner","control":_vm.registry.allow_ocr_scanner,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_ocr_scanner),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_ocr_scanner", $$v)},expression:"innerValue.allow_ocr_scanner"}})]}}],null,true)}),(_vm.canManageAutomaticMapping)?_c('div',{staticClass:"automatic-mapping"},[_c('validation-provider',{attrs:{"slim":true,"name":"allow_automatic_mapping"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_automatic_mapping","control":_vm.registry.allow_automatic_mapping,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_automatic_mapping),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_automatic_mapping", $$v)},expression:"innerValue.allow_automatic_mapping"}})]}}],null,true)}),(_vm.canEditPrompt)?_c('span',{staticClass:"edit-prompt"},[_c('a',{staticClass:"has-action",on:{"click":function($event){$event.preventDefault();return _vm.editPrompt.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('leads.settings.edit_prompt')))]),_vm._v(" "+_vm._s(_vm.$t('leads.settings.for_the_automatic_mapping')))]):_vm._e()],1):_vm._e(),_c('validation-provider',{attrs:{"slim":true,"name":"allow_manual_input"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"allow_manual_input","control":_vm.registry.allow_manual_input,"settings":_vm.settings,"event":_vm.params.event,"errors":errors},model:{value:(_vm.innerValue.allow_manual_input),callback:function ($$v) {_vm.$set(_vm.innerValue, "allow_manual_input", $$v)},expression:"innerValue.allow_manual_input"}})]}}],null,true)})]}}:null,(_vm.showCaptureMethods)?{key:"enrichment",fn:function(ref){return [_c('leads-enrichment-settings',{attrs:{"eid":_vm.params.event._id},on:{"save-settings":_vm.save},model:{value:(_vm.innerValue.enrichment_integrations),callback:function ($$v) {_vm.$set(_vm.innerValue, "enrichment_integrations", $$v)},expression:"innerValue.enrichment_integrations"}})]}}:null,{key:"presentation",fn:function(ref){return [_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.qualification_page.intro_1')))]),_c('p',[_vm._v(_vm._s(_vm.$t('leads.settings.qualification_page.intro_2')))]),_c('validation-provider',{attrs:{"slim":true,"name":"qualification_page"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('meta-control',{attrs:{"name":"qualification_page","edit":true,"control":_vm.registry.qualification_page,"settings":_vm.settings,"event":_vm.params.event,"errors":errors,"allow-empty":false},model:{value:(_vm.innerValue.qualification_page),callback:function ($$v) {_vm.$set(_vm.innerValue, "qualification_page", $$v)},expression:"innerValue.qualification_page"}})]}}],null,true)})]}}],null,true)}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}],null,false,3958772513)})],1)]):_vm._e()])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "LeadsSettings.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__